import Link from "next/link";
import { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";

import { SiteTypes } from "~/redux/reducers/paramsReducer";
import { safeLocalStorage } from "~/utils/safeStorage";

import BaltexSections from "../../baltex/sections";
import Breadcrumbs from "../../common/breadcrumbs";
import CatalogSide from "../../layouts/catalogSide";
import styles from "./index.module.scss";
import SectionsTree from "./sectionsTree";

export default function Sections({ section }: any) {
  const { sections } = useSelector((state: any) => state.sections);
  const id = section ? section.ID : null;
  const title = section ? section.NAME : "Каталог";
  const sectionsMap = sections ?? {};
  const childSections = Object.values(sectionsMap).filter(
    (section: any) => section.IBLOCK_SECTION_ID === id,
  );
  const childSectionsSorted = useMemo(() => {
    return childSections.sort((a: any, b: any): any => a.SORT - b.SORT);
  }, childSections);
  const [filterUrl, setFilterUrl] = useState("");

  useEffect(() => {
    const storedFilterUrl = safeLocalStorage.getItem("filterUrl");
    if (storedFilterUrl && !storedFilterUrl.includes("-0/")) {
      setFilterUrl(storedFilterUrl);
    }
  });

  const { siteType } = useSelector((state: any) => state.params);
  const isBaltex = useMemo(() => {
    return siteType === SiteTypes.Baltex;
  }, [siteType]);

  return isBaltex ? (
    <div className="container">
      <div className={styles.Content}>
        <Breadcrumbs />
        <h1 className={styles.BaltexH1}>{title}</h1>
        <BaltexSections />
      </div>
    </div>
  ) : (
    <CatalogSide
      side={<SectionsTree filterUrl={filterUrl} sectionId={section?.ID} />}
    >
      <div>
        <h1>{title}</h1>
        <div className={styles.Sections}>
          {childSectionsSorted.map((section: any) => (
            <Link
              href={
                section.SECTION_PAGE_URL +
                (section.CHILD?.length > 0 ? "" : filterUrl)
              }
              key={section.ID}
            >
              {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
              <a className={styles.Section}>
                <div>
                  <img
                    src={section.DETAIL_PICTURE_PATH}
                    alt={section.NAME}
                    title={section.NAME}
                  />
                </div>
                <span>{section.NAME}</span>
              </a>
            </Link>
          ))}
        </div>
      </div>
    </CatalogSide>
  );
}
